import React, {memo} from 'react';
import styled from 'styled-components';

import {Btn, Icon} from '../../../../ui-toolkit';
import {Table} from '../../../../ui-toolkit/indexExportV2';

import {EntityTableCol} from './EntityTableCol';

const EntityTableRow = memo(({row, entityType, t}) => {
    const {rowClick, rowPeek, isMarked, columns} = row;
    return (
        <Table.Row
            hover
            onClick={rowClick}
            color={isMarked ? 'container-background-active-color-100' : ''}
            data-row-id={row.rowId}>
            {columns.map((attr) => (
                <EntityTableCol key={attr.columnInfo.columnId} column={attr} row={row} t={t} entityType={entityType} />
            ))}
            <Table.Data textAlign="right">
                {rowPeek && (
                    <ModalBtn
                        color="primary-table"
                        link="true"
                        onClick={(e) => {
                            e.stopPropagation();
                            rowPeek();
                        }}>
                        <Icon name="ZoomIn" />
                    </ModalBtn>
                )}
            </Table.Data>
        </Table.Row>
    );
});
EntityTableRow.displayName = 'EntityTableRow';

const ModalBtn = styled(Btn)`
    padding: 0 !important;
    ${Icon.Wrapper} {
        svg {
            width: calc(var(--table-column-body-text-size) + 3px) !important;
            height: calc(var(--table-column-body-text-size) + 4px) !important;
        }
    }
`;

export default EntityTableRow;
